// client/src/services/billingDetailService.js
import api from './api';

const billingDetailService = {
  getBillingDetails: async () => {
    const response = await api.get('/billing-details');
    return response.data;
  },
  
  getBillingDetail: async (id) => {
    const response = await api.get(`/billing-details/${id}`);
    return response.data;
  },
  
  createBillingDetail: async (detailData) => {
    const response = await api.post('/billing-details', detailData);
    return response.data;
  },
  
  updateBillingDetail: async (id, detailData) => {
    const response = await api.put(`/billing-details/${id}`, detailData);
    return response.data;
  },
  
  deleteBillingDetail: async (id) => {
    const response = await api.delete(`/billing-details/${id}`);
    return response.data;
  },

  getAvailableDetailsForBylaw: async (bylawId, transactionId = null) => {
    const response = await api.get(`/billing-details/available-for-bylaw/${bylawId}`, {
      params: transactionId ? { transactionId } : {},
    });
    return response.data;
  }
};

export default billingDetailService;